import { EFinancingCompany } from '@if/core/types'
import * as yup from '@if/core/yup'

export interface LoginCredentials {
  username: string
  password: string
  companyIds: EFinancingCompany[]
}

export const LoginCredentialsSchema = yup.object({
  username: yup.string().required(),
  password: yup.string().required(),
})
